export default __webpack_public_path__ + "static/media/ChatroomNotAuthenticatedQR.88b47c5e.png";